import type { ToastModel } from '@boostbrothers/web-ui/web';
import { atom, useAtom } from 'jotai';

const toastsAtom = atom<ToastModel[]>([]);

const useToast = () => {
  const [toasts, setToasts] = useAtom(toastsAtom);

  const addToast = (toast: Omit<ToastModel, 'itemKey'>) => {
    const newToast: ToastModel = { ...toast, itemKey: `${Date.now()}` };
    setToasts(prev => [...prev, newToast]);
  };

  const closeToast = (key: string) => {
    setToasts(prev => prev.filter(toast => toast.itemKey !== key));
  };

  return {
    toasts,
    addToast,
    closeToast,
  };
};

export default useToast;
